module.exports = __webpack_public_path__ + "img/embedded4.8d488939.png";